export default {"src":"/_next/static/media/icon-new-tag.33613033.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};